import { AudioAsesoria } from '@/types/types';
import { api } from './api';

export interface AudioHistorico {
  audioId: number;
  asesorId: number;
  asesoriaId: number;
  empresaId: string;
  adjunteDelAudio: string;
  duracionSeg: number;
  email: string | null;
  fechaGrabacion: string;
  empresa: {
    nombre: string;
    nitId: string;
  };
}

export interface AudiosActivaResponse {
  success: boolean;
  asesoria: {
    audios?: AudioAsesoria[];
  };
}

export interface AudioFormUrlResponse {
  success: boolean;
  formUrl: string;
  source: 'DB' | 'GENERATED';
  dbFormUrl?: string | null;
  generatedUrl?: string;
}

export interface AudioFechaResponse {
  audioId: number;
  fechaGrabacion: string;
  resumenCorto: string | null;
  duracionSeg: number;
}

export interface UpdateAudioFechaResult {
  success: boolean;
  message: string;
  audio?: AudioFechaResponse;
}

export const audiosService = {
  async getAudiosActiva(nit: string): Promise<AudiosActivaResponse> {
    return api.get<AudiosActivaResponse>(`/empresas/${nit}/asesorias?estado=activa`);
  },

  async getFormUrl(nit: string): Promise<AudioFormUrlResponse> {
    return api.get<AudioFormUrlResponse>(`/empresas/${nit}/asesoria-activa/form-url`);
  },

  async updateFechaGrabacion(nit: string, audioId: number, fechaGrabacion: Date | string): Promise<UpdateAudioFechaResult> {
    const isoDate = typeof fechaGrabacion === 'string' ? fechaGrabacion : fechaGrabacion.toISOString();

    return api.patch<UpdateAudioFechaResult>(`/empresas/${nit}/asesoria-activa/audios/${audioId}/fecha`, { fechaGrabacion: isoDate });
  },

  async deleteAudio(nit: string, audioId: number): Promise<{ success: boolean; message: string }> {
    return api.delete<{ success: boolean; message: string }>(`/empresas/${nit}/asesoria-activa/audios/${audioId}`);
  },

  async requestAudioAccess(nit: string, audioId: number, email?: string): Promise<{ success: boolean; message: string }> {
    return api.post<{ success: boolean; message: string }>(`/empresas/${nit}/asesoria-activa/audios/${audioId}/acceso`, {
      email: email?.trim() ? email.trim() : undefined,
    });
  },

  async requestFormAccess(nit: string, email?: string): Promise<{ success: boolean; message: string }> {
    return api.post<{ success: boolean; message: string }>(`/empresas/${nit}/asesoria-activa/form-url/acceso`, { email });
  },

  async getHistorico(): Promise<AudioHistorico[]> {
    const response = await api.get<{ success: boolean; data: AudioHistorico[] }>('/asesor/mis-audios');
    return response.data;
  },
};
